import { render } from "./TransactionManagment.vue?vue&type=template&id=59a47741&scoped=true"
import script from "./TransactionManagment.vue?vue&type=script&lang=js"
export * from "./TransactionManagment.vue?vue&type=script&lang=js"

import "./TransactionManagment.vue?vue&type=style&index=0&id=59a47741&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a47741"]])

export default __exports__